import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';
import { PlayerProvider, usePlayer } from './contexts/PlayerContext';
import AudioPlayer from './components/AudioPlayer';
import './App.css';

// Lazy loading для всех страниц для оптимизации загрузки
const HomePage = lazy(() => import('./pages/HomePage'));
const SearchPage = lazy(() => import('./pages/SearchPage'));
const TracksPage = lazy(() => import('./pages/TracksPage'));
const DownloadPage = lazy(() => import('./pages/DownloadPage'));
const AuthPage = lazy(() => import('./pages/AuthPage'));
const AccountPage = lazy(() => import('./pages/AccountPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));

// Компонент загрузки
const LoadingFallback = () => (
                <div style={{ 
                  minHeight: '100vh', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  background: '#0a0a0f',
                  color: '#fff'
                }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      width: '50px',
                      height: '50px',
                      border: '5px solid rgba(102, 126, 234, 0.2)',
                      borderTop: '5px solid #667eea',
                      borderRadius: '50%',
                      animation: 'spin 0.8s linear infinite',
                      margin: '0 auto 1rem'
                    }}></div>
                    <p>Загрузка...</p>
                  </div>
                </div>
);

function AppContent() {
  const { playingTrack, playUrl, wavePlaylist, currentWaveIndex, nextTrackUrl, beatSpeed, setBeatSpeed, isPlaying, setIsPlaying, handleStop, playNextTrack, playPrevTrack } = usePlayer();

  return (
    <div className="App">
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* общая страница /dj убрана: у каждого DJ своя — /ник */}
          <Route path="/dj" element={<Navigate to="/" replace />} />
          <Route path="/tracks" element={<TracksPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/admin" element={<AdminPage />} />
          {/* /high — та же главная страница, но линии объектов анимированы по максимуму */}
          <Route path="/high" element={<HomePage />} />
          {/* личная страница DJ: заказ треков в его очередь. Должна идти ПОСЛЕДНЕЙ, после фиксированных путей */}
          <Route path="/:nick" element={<SearchPage />} />
        </Routes>
      </Suspense>

      {/* Глобальный плеер - виден на всех страницах */}
      {playingTrack && playUrl && (
        <AudioPlayer 
          track={playingTrack} 
          playUrl={playUrl}
          onStop={handleStop}
          onNext={wavePlaylist.length > 0 ? playNextTrack : null}
          onPrev={wavePlaylist.length > 0 ? playPrevTrack : null}
          hasNext={wavePlaylist.length > 0 && currentWaveIndex < wavePlaylist.length - 1}
          hasPrev={wavePlaylist.length > 0 && currentWaveIndex > 0}
          nextTrackUrl={nextTrackUrl}
          onBeatSpeed={setBeatSpeed}
          onIsPlayingChange={setIsPlaying}
        />
      )}
      </div>
  );
}

function App() {
  return (
    <UserProvider>
      <PlayerProvider>
        <Router>
          <AppContent />
    </Router>
      </PlayerProvider>
    </UserProvider>
  );
}

export default App;

